import React, { Component } from "react";
import Navbar from "../components/NavbarHome";
import { Link } from "react-router-dom";
import "../styles/about.css";
import car from "../images/lamborghini.png";
import parkingSign from "../images/parking-loc.png";
import Footer from "../components/Footer";

//redux
import { connect } from "react-redux";

//animation
import styled, { keyframes } from "styled-components";
import { bounceInRight, flip } from "react-animations";
import LoadingPage from "../components/LoadingPage";

const bounceAnimation = keyframes`${bounceInRight}`;
const BouncyDiv = styled.div`
  animation: 2s ${bounceAnimation};
`;

const Flip = styled.div`
  animation: 2s ${keyframes`${flip}`};
`;

export class about extends Component {
  state = {
    loading: false
  };

  render() {
    return (
      <div>
        {this.state.loading ? (
          <LoadingPage />
        ) : (
          <div>
            <Navbar />
            <section className="site-blocks-cover bg-light">
              <div className="container">
                <div className="row hero-div">
                  <div className="col-md-6">
                    <div className="intro-text">
                      <h1>FIND THE PERFECT SPOT</h1>
                      <h6>
                        Neque porro quisquam est qui dolorem ipsum quia dolor
                        sit amet,
                        <br /> consectetur, adipisci velit
                      </h6>
                      <BouncyDiv className="reserve-div">
                        <Link to="/login">
                          <button className="img-fluid btn mt-4">
                            Reserve now!
                          </button>
                        </Link>
                      </BouncyDiv>
                    </div>
                  </div>
                  <div className="col-md-6 hero-right-div">
                    <img src={parkingSign} alt="" className="parking-sign" />
                    <img src={car} alt="" className="car" />
                  </div>
                </div>
              </div>
            </section>
            <div className="steps-section">
              <div className="auto-container">
                <h1 className="text-center">How It Works</h1>
                <div className="row steps-div">
                  <div className="steps-block col-lg-4 col-md-6 col-sm-12">
                    <div className="inner-box">
                      <Flip>
                        <div className="step-box">
                          <h1>1</h1>
                        </div>
                      </Flip>
                      <h5>Login</h5>
                      <p>hello hello hello hello hello hello</p>
                    </div>
                  </div>
                  <div className="steps-block col-lg-4 col-md-6 col-sm-12">
                    <div className="inner-box">
                      <div className="step-box">
                        <h1>2</h1>
                      </div>
                      <h5>Select a parking spot</h5>
                      <p>hello hello hello hello hello hello</p>
                    </div>
                  </div>
                  <div className="steps-block col-lg-4 col-md-6 col-sm-12">
                    <div className="inner-box">
                      <div className="step-box">
                        <h1>3</h1>
                      </div>
                      <h5>Payment</h5>
                      <p>hello hello hello hello hello hello</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.ui.loading
});

export default connect(mapStateToProps)(about);
